// const $ = require('jquery');

export function handleCustomDropdownEvents() {

  let dropdownMenu, target;
  $(window).on('show.bs.dropdown', onDropdownShow);          
  $(window).on('hide.bs.dropdown', onDropdownHide);
  $(window).on('scroll.customDropdown resize.customDropdown', onScrollOrResize);

  function onDropdownHide(e) {
    if (target && dropdownMenu && $(".overflow-dropdown").length > 0) {
      target.append(dropdownMenu.detach());
      dropdownMenu.hide();
    }
  }

  function onDropdownShow(e) {
    target = $(e.target);
    if (target.hasClass("overflow-dropdown")) {
      dropdownMenu = target.find('.dropdown-menu');
      $('body').append(dropdownMenu.detach());
      var eOffset = $(e.target).offset();
      dropdownMenu.css({
        'display': 'block',
        'top': eOffset.top + $(e.target).outerHeight(),
        'left': eOffset.left
      });
    }
  }

  function onScrollOrResize() {
    if (target && target.length > 0 && target.hasClass('overflow-dropdown')) {
      if (target) {
        target.removeClass('open');
      }
      onDropdownHide();
    }
  }
};


// WEBPACK FOOTER //
// ./src/utilities/customBootstrapDropdowns/index.js